import { Dimensions, StyleSheet } from "react-native"
import { colors, typography } from "theme"

export const style = StyleSheet.create({
  // Carousel container styles
  carouselContainer: {
    justifyContent: "center",
  },
  carouselImage: {
    height: "100%",
    resizeMode: "contain",
    width: "100%",
  },
  carouselImageContainer: {
    alignItems: "center",
    height: "100%",
    justifyContent: "center",
    width: "100%",
  },
  container: {
    overflow: "hidden",
  },

  // Details container for tier description and benefits
  detailsContainer: {
    backgroundColor: colors.background,
    // borderTopLeftRadius: 50,
    // borderTopRightRadius: 50,
    padding: 20,
  },

  // Header container styles
  headerContainer: {
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
  },
  paginationDotContainer: {
    alignSelf: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 20,
  },

  // New styles for tier details and benefits
  benefitContainer: {
    alignItems: "center",
    backgroundColor: colors.palette.lightGray,
    borderRadius: 10,
    flexDirection: "row",
    marginVertical: 10,
    padding: 10,
  },
  benefitDescription: {
    color: colors.palette.gray,
    fontSize: 14,
  },
  benefitImage: {
    borderRadius: 100,
    height: 50,
    marginRight: 15,
    resizeMode: "contain",
    width: 50,
  },
  benefitTitle: {
    color: colors.palette.darkGray,
    fontSize: 18,
    fontWeight: "bold",
  },
  tierContentContainer: {
    borderRadius: 10,
    padding: 15,
    minHeight: 180,
    overflow: "hidden",
  },

  tierBoxFlex: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: 15,
  },
  image: {
    height: "100%",
    width: "100%",
    resizeMode: "contain",
  },
  tierBoxRight: {
    width: "70%",
    height: "100%",
  },
  TierTitleContainer: {
    display: "flex",
    width: "100%",
  },
  tierTitle2: { fontFamily: typography.primary.normal, fontSize: 28 },
  benefitText: {
    fontFamily: typography.primary.normal,
    alignSelf: "center",
    alignItems: "center",
  },
  pointImage: {
    width: 30,
    height: 30,
    resizeMode: "contain",
    marginRight: 15,
  },
  textContainer: { alignSelf: "flex-start", fontSize: 12, marginBottom: 5 },
  text: { fontFamily: typography.primary.normal, marginTop: 10, alignSelf: "flex-end" },
  borderContainer: {
    marginBottom: 10,
    elevation: 8,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.3,
    shadowRadius: 6,

    // Border for light edge effect
    borderColor: "#d9d9d9",
    borderRadius: 10,
  },
  tierSpendText: {
    color: colors.white,
    fontFamily: typography.primary.normal,
  },
  tierText: {
    color: colors.white,
    fontFamily: typography.primary.normal,
    marginBottom: 10,
  },
  voucherContainer: { marginRight: 20 },
  voucherImage: {
    alignSelf: "center",
    borderRadius: 10,
  },
})
